import api from "./api";

const FeatureAppAPI = {
    getAll: () => api.get("/feature-apps/all"),
};

export default FeatureAppAPI;